import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function PricingSection() {
  return <section id="offer" className="scroll-mt-20 bg-brand-alt px-4 py-20 md:py-28" data-id="element-128" data-mp="19jxdvgf8bdcx">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-129" data-mp="1ehytfrdg4ujn">
        <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-green" data-id="element-130" data-mp="1egdyw1r4tbls">PRECIO POR TIEMPO LIMITADO</p>
        <h2 className="mb-12 text-3xl font-black text-brand-deep md:text-4xl" data-id="element-131" data-mp="1nasph0h448k7">Oferta especial de lanzamiento</h2>
        <div className="relative mx-auto max-w-xl overflow-hidden rounded-[2rem] border-2 border-brand-green bg-brand-alt shadow-xl" data-id="element-132" data-mp="1s93xr6rreb0b">
          <div className="bg-brand-deep px-6 py-4 text-[11px] font-extrabold tracking-[0.14em] text-white" data-id="element-133" data-mp="1x99kq9n339c2">
            BIOLOGÍA LISTA — PACK COMPLETO
          </div>
          <div className="p-8 md:p-12" data-id="element-134" data-mp="2vgzxjze7xor">
            <div className="space-y-4 text-left" data-id="element-135" data-mp="2wjqfqsszy45">
              <PriceLine label="Pack completo Biología Lista" price="USD 67" data-id="element-136" data-mp="7ta64d0p4rp1" />
              <PriceLine label="5 bonos exclusivos" price="GRATIS" data-id="element-137" data-mp="1mgofre9i7flx" />
              <div className="flex items-center justify-between border-t border-brand-dark pt-5 text-sm font-bold" data-id="element-138" data-mp="1mhzj5cz1elci">
                <span data-id="element-139" data-mp="1ho51sg6wmigl">PRECIO TOTAL:</span>
                <span className="text-brand-green line-through" data-id="element-140" data-mp="1cq3ko0t1gt7r">USD 67</span>
              </div>
            </div>
            <div className="my-8 border-y border-brand-dark py-7" data-id="element-141" data-mp="17sto8178fhaf">
              <p className="text-xs font-extrabold tracking-[0.16em] text-brand-green" data-id="element-142" data-mp="25faj6zshtit0">SOLO HOY</p>
              <p className="mt-2 font-serif text-6xl font-black tracking-tight text-brand-deep md:text-7xl" data-id="element-143" data-mp="20gphsx1i8t2z">
                USD <span className="whitespace-nowrap" data-id="element-144" data-mp="1vgl9vvenx6od">19</span>
              </p>
            </div>
            <CTAButton href="https://biologia-lista.impultienda.ar/checkout" className="w-full py-5 text-lg" data-id="element-145" data-mp="1rgauxt8w75xd">
              QUIERO EL PACK BIOLOGÍA LISTA
            </CTAButton>
            <p className="mt-6 text-xs font-semibold text-brand-gray" data-id="element-146" data-mp="g0m76znte2vi">
              Pago único · Descarga inmediata · Acceso de por vida
            </p>
          </div>
        </div>
      </Reveal>
    </section>;
}
function PriceLine({
  label,
  price
}: {
  label: string;
  price: string;
}) {
  return <div className="flex items-center justify-between border-b border-brand-dark pb-4 text-sm" data-id="element-147" data-mp="7jlqkescvphr">
      <span className="font-medium" data-id="element-148" data-mp="ciom98mg4jd2">{label}</span>
      <span className="font-bold text-brand-deep" data-id="element-149" data-mp="chdn5m3y3zsa">{price}</span>
    </div>;
}